import { Controller } from "@hotwired/stimulus"

/**
 * Users Bulk Action Controller
 *
 * Handles bulk actions on user lists including:
 * - Opening modals for bulk actions (update question, update session, delete)
 * - Transferring selected user IDs from main form to modal forms
 * - Clearing "all" input field when individual inputs change
 *
 * Usage:
 *   <div data-controller="users-bulk-action">
 *     <select data-users-bulk-action-target="actionSelect">...</select>
 *     <button data-action="click->users-bulk-action#executeAction">Go</button>
 *     <form data-users-bulk-action-target="mainForm">...</form>
 *   </div>
 */
export default class extends Controller {
  static targets = ["actionSelect", "mainForm", "allInput"]

  /**
   * Execute the selected bulk action
   * Opens the appropriate modal and transfers selected IDs
   *
   * @param {Event} event - Click event from Go button
   */
  executeAction(event) {
    event.preventDefault()

    // Get selected action and URL
    const actionSelect = this.actionSelectTarget
    const selectedOption = actionSelect.options[actionSelect.selectedIndex]
    const action = actionSelect.value
    const url = selectedOption.getAttribute('data-url')

    // Check if we should update the main form action (for quota management)
    const changeForm = event.currentTarget.dataset.usersBulkActionChangeFormParam === 'true'

    // Find the modal element
    const modalElement = document.getElementById(action)
    if (!modalElement) {
      console.error(`Modal not found for action: ${action}`)
      return
    }

    // Update main form action if needed (for quota management bulk actions)
    if (changeForm && url) {
      const multiForm = document.querySelector('.multi-form')
      if (multiForm) {
        multiForm.setAttribute('action', url)
      }
    }

    // Get selected IDs from main form
    const formData = new FormData(this.mainFormTarget)
    const selectedIds = formData.getAll('ids[]')

    // Transfer IDs to modal form
    const modalForm = modalElement.querySelector('form')
    if (modalForm) {
      const idsInput = modalForm.querySelector('input[name="ids[]"]')
      if (idsInput) {
        idsInput.value = JSON.stringify(selectedIds)
      }
    }

    // Open the modal using Bootstrap's modal API
    const modal = new bootstrap.Modal(modalElement)
    modal.show()
  }

  /**
   * Clear the "all" input field when individual question inputs change
   * This is called when users edit individual current question numbers
   */
  clearAll() {
    if (this.hasAllInputTarget) {
      this.allInputTarget.value = ""
    }
  }
}
